import { render } from "./Questionnaire.vue?vue&type=template&id=2da32340&scoped=true&ts=true"
import script from "./Questionnaire.ts?vue&type=script&lang=ts"
export * from "./Questionnaire.ts?vue&type=script&lang=ts"

import "./Questionnaire.scss?vue&type=style&index=0&id=2da32340&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da32340"]])

export default __exports__